import type { DssOi } from '@/lib/api/types';
import { overlapsHour } from '@/lib/oi/oiTime';
import Fuse, { type IFuseOptions } from 'fuse.js';

const EXTERNAL_KEYS: IFuseOptions<DssOi>['keys'] = [
  { name: 'oi_id', weight: 2 },
  { name: 'operator', weight: 1 },
  { name: 'op_type', weight: 0.5 },
];

/** The one 3rd Party filter — the list and the map both call it so they can
 *  never disagree. `hour === null` (nothing picked on the scrubber) keeps
 *  every stage: planned, active and ended. Status chips never apply. */
export function filterExternalOis(
  external: DssOi[],
  o: { hour: number | null; query: string; now: number },
): DssOi[] {
  const inHour =
    o.hour === null
      ? external
      : external.filter((oi) => overlapsHour(oi.start_utc, oi.end_utc, o.hour as number, o.now));
  const term = o.query.trim();
  if (!term) return inHour;
  return new Fuse(inHour, { keys: EXTERNAL_KEYS, threshold: 0.35, ignoreLocation: true })
    .search(term)
    .map((r) => r.item);
}
